export default __webpack_public_path__ + "static/media/steps.af7c9096.mp3";